import React, { useEffect, useCallback, useMemo } from 'react'
// import { connect } from 'react-redux'
import _ from 'lodash'
import { Panel, Tree, TreeColumn, NumberColumn } from '@sencha/ext-modern'

import { useInstData } from 'tyan/public/hooks'
import { getModel, handleItemContextMenu } from '../column'
import { fetchManagerCategories } from './managerUtils'

const genNodeId = data => data && `${data.type}_${data.id}`
const genCategory = data => data && { type: data.type, id: data.id }

const Categories = props => {
	const { stamp, pathname, config: propsConfig, sampleCategoriesData, tabName, sampleData, onChange, that: { showDetail }, showFetchSpinner } = props
	const config = useMemo(() => !propsConfig ? null : Ext.apply({
		width: '280',
		countWidth: 'auto'
	}, propsConfig === true ? {} : propsConfig), [propsConfig])

	const { me, setState, me: { state: { store } } } = useInstData(props, useCallback(() => ({
		state: {
			list: null,
			store: config ? new Ext.data.TreeStore({
				model: getModel(null, { idProperty: '_id' }), rootVisible: false,
				root: { expanded: true, children: [/* { text: '加载中...', expanded: true } */] },
			}) : null
		},
		stampForGetCategories: null, stamp, category: null, selected: null
	}), []))

	const { me: forThat } = useInstData(null, () => ({
		showDetail,
		refresh: newCategory => {
			newCategory && (me.category = { type: newCategory.type, id: newCategory.id })
			doGetCategories()
		},
		setCategory: ({ type, id } = {}) => {
			me.category = { type, id }
			checkCategory()
		}
	}))

	const checkCategory = useCallback(() => {
		const { category: current, grid, state: { list }, selected: prevSelected, relatives: { next, prev, parent } = {} } = me
		if (!list || !grid) return

		const category = [current, prevSelected, next, prev, parent].find(c => c && grid.store.byIdMap[genNodeId(c)])
			|| genCategory(list[0]) || null

		const selected = genCategory(grid && grid.getSelection() && grid.getSelection().data)

		category && (
			_.isEqual(category, selected)
				? (onChange && onChange(category))
				: (() => {
					const data = grid && grid.store.byIdMap[genNodeId(category)]
					data && grid.getSelectable().select(data)
				})()
		)
	}, [])

	const doGetCategories = useCallback(() => {
		const { expandLevel = Infinity } = config

		const reArrangeTreeData = (data, level = 1) => {
			data.forEach(item => {
				level === 1 && (item.text = Tyan.t(item.text))
				item._id = genNodeId(item)
				// item.count = item.count || ''
				if (item.children && item.children.length > 0) {
					item.expanded = level <= expandLevel // true
					// item.iconCls = 'x-fa fa-folder'
					reArrangeTreeData(item.children, level + 1)
				} else {
					item.leaf = true
					// item.iconCls = 'x-fa fa-folder'
				}
			})
			return data
		}

		const stamp = me.stampForGetCategories = Date.now()

		fetchManagerCategories(pathname, {
			tabName, sampleCategoriesData, showFetchSpinner,
			onSuccess: ({ categories: list }) => {
				if (me.unmounted || stamp != me.stampForGetCategories || _.isEqual(list, me.state.list))
					return

				me.state.list = _.cloneDeep(list)

				list = reArrangeTreeData(list || [])
				// console.log('list:', list)
				const root = { expanded: true, children: list }
				const store = me.state.store

				const newStore = store ? (store.setRoot(root), store) : new Ext.data.TreeStore({
					model: getModel(null, { idProperty: '_id' }), rootVisible: false,
					root
				})

				setState({ store: newStore })
				checkCategory()
			},

			onFailure: ({ errorMessage }) => { Ext.toast(errorMessage), console.error(errorMessage) }
		})
	}, [config])

	// useEffect(() => {
	// 	config ? doGetCategories() : onChange(null)
	// }, [])

	useEffect(() => {
		/* stamp != me.stamp &&  */config ? doGetCategories() : onChange(null)
	}, [stamp])

	const handleSelect = (tree, selected) => {
		const { type, id } = selected.data
		me.category = me.selected = { type, id }
		me.relatives = {
			prev: genCategory(selected.previousSibling && selected.previousSibling.data),
			next: genCategory(selected.nextSibling && selected.nextSibling.data),
			parent: genCategory(selected.parentNode && !selected.parentNode.isRoot() && selected.parentNode.data)
		}
		checkCategory()
	}

	if (!config) return null

	// const optGridProps = {}
	// countWidth: count列宽度，默认'auto'
	// columnLines: 显示列分隔线，默认false
	const { countWidth, contextmenu, onDoubleTap, expandLevel, ...optGridProps } = config
	// columnLines && (optGridProps.columnLines = true)
	contextmenu && (optGridProps.onChildContextMenu = optGridProps.onChildLongPress = (grid, { record, event }) => handleItemContextMenu(contextmenu, grid, record, event, forThat))
	onDoubleTap && (optGridProps.onChildDoubleTap = (grid, { record }) => onDoubleTap(forThat, record.data, record, grid))

	return <Panel layout='fit' docked='left' resizable={{ edges: 'east', dynamic: true }} margin="5 0 10 10" shadow >
		<Tree ref={ref => ref && (me.grid = ref.cmp)} flex={1} scrollable itemConfig={{ viewModel: {} }} selectable={{ mode: 'single' }} hideHeaders={true}
			store={store}
			onSelect={handleSelect}
			{...optGridProps}
		>
			<TreeColumn dataIndex='text' flex={1} />
			<NumberColumn dataIndex='count' width={countWidth || 'auto'} align='right' format="0,0" />
		</Tree>
	</Panel>
}

// export default connect()(Categories)
export default Categories